import { useEffect, useRef } from 'react';
import { change } from 'redux-form';
import { isSiretCountry, deriveElectronicAddress } from '../shared/country';

// Seeds and keeps the electronic address (BT-49) in sync with the SIRET on a business form.
// It seeds an empty address on the first pass, never overwrites a value already loaded from the
// record or typed by the user, and re-derives on later SIRET edits. This applies to every SIRET
// country, whether the SIRET is mandatory (mainland France) or optional (Monaco, overseas
// territories). Keyed only on siretSiren + country so dispatching a new electronicAddress does not
// re-trigger the effect.
const useElectronicAddressSync = ({ formName, dispatch, businessCountryCode, siretSiren, electronicAddress }) => {
  const didSeed = useRef(false);

  useEffect(() => {
    if (!isSiretCountry(businessCountryCode) || !siretSiren) {
      return;
    }
    // On the first pass only fill an empty address; never rewrite a value the user already has.
    if (!didSeed.current) {
      didSeed.current = true;
      if (electronicAddress) {
        return;
      }
    }
    const derived = deriveElectronicAddress(electronicAddress, siretSiren);
    if (derived !== electronicAddress) {
      dispatch(change(formName, 'electronicAddress', derived));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siretSiren, businessCountryCode]);
};

export default useElectronicAddressSync;
